import React, { FC, memo } from 'react';
import styled from 'styled-components';
import FormikInput from '@minecraft.formik-input';
import { FilterData } from '../../../shared/types';
import { Label } from '../../../shared/styles';

const StyledFormikInput = styled(FormikInput)`
  min-width: 9.375rem;
`;

type Props = FilterData;

const VehicleModel: FC<Props> = ({ name, label }) => {
  return (
    <>
      <Label>{label}</Label>
      <StyledFormikInput name={name} maxLength={50} size="small" />
    </>
  );
};

export default memo(VehicleModel);
